export const notificationTypeConfig = {
  "SPRINT STARTED": { icon: "🚀", color: "#624bff" },
  "TASK MOVED": { icon: "🔄", color: "#20c997" },
  "COMMENT ADDED": { icon: "💬", color: "#fd7e14" },
  DEFAULT: { icon: "🔔", color: "#6c757d" },
};
